import { useState } from 'react'
import { toast } from 'react-toastify'
import { startSxpProxy } from '../utils/api'
import { CHAT_PROJECT_ID } from '../utils/constants'

export const usePatientSearchByMuhid = (getPatientDetailsByIdentifier: any) => {
  const [loading, setLoading] = useState(false)

  const searchPatient = async (muhId: string) => {
    if (!muhId) {
      return { success: false, data: null }
    }

    setLoading(true)
    try {
      const response = await startSxpProxy(
        CHAT_PROJECT_ID,
        getPatientDetailsByIdentifier,
        { patientIdentifier: muhId }
      )

      const entry = response?.data?.entry
      if (entry?.length > 0) {
        const patientId = entry[0]?.resource?.id
        return { success: true, data: { patientId, entry } }
      } else {
        toast.error('Enter Proper Patient MUHID')
        return { success: false, data: null }
      }
    } catch (error) {
      console.error('Patient search error:', error)
      toast.error('Failed to fetch patient details')
      return { success: false, data: null }
    } finally {
      setLoading(false)
    }
  }

  return { searchPatient, loading }
}
